/** Everyone registered for the studio's session, the people here first: who is coming, read when the studio opens. */
import { useCallback, useEffect, useState } from "react";
import type { LivePerson } from "../../shared/types";
import { api } from "../lib/api";

export function useStudioPeople(webinarId: string, sessionId: string, on: boolean): { people: LivePerson[] | null; reload: () => void } {
  const [people, setPeople] = useState<LivePerson[] | null>(null);
  const [round, setRound] = useState(0);
  useEffect(() => {
    if (!on) return;
    let alive = true;
    api.studio
      .people(webinarId, sessionId)
      .then((res) => alive && setPeople(res.people))
      .catch(() => alive && setPeople((was) => was ?? []));
    return () => {
      alive = false;
    };
  }, [webinarId, sessionId, on, round]);
  const reload = useCallback(() => setRound((n) => n + 1), []);
  return { people, reload };
}
